<template>
    <base-list-with-heading-entry class="relative">
        <div class="flex-1">
            <div class="flex flex-wrap">
                <span class="text-gray-700 text-base font-bold mr-2">
                    <a :href="this.detailRoute()" class="boxLink">{{ interruption.name }}</a>
                </span>
                <div class="px-2 py-1 text-xs rounded-full font-bold leading-tight flex items-center" :class="{'text-red-800 bg-red-200' : ongoing, 'text-green-800 bg-green-200' : resolved}">
                    <div class="w-1 h-1 rounded-full" :class="{'bg-red-400' : ongoing, 'bg-green-400' : resolved}"></div>
                    <span class="ml-1" v-if="ongoing">Ongoing</span>
                    <span class="ml-1" v-if="resolved">Resolved</span>
                </div>
            </div>
            <div class="text-gray-700 text-sm mt-2" v-if="interruption.comment">
                <strong>Further information</strong>: <p v-html="interruption.comment"></p>
            </div>
        </div>
        <div class="mt-2 xl:mt-0 ml-0 xl:ml-auto flex flex-wrap flex-col">
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" class="text-gray-500 inline" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                <span class="text-gray-600 text-sm ml-2">{{ interruption.started_at_human_readable }}</span>
            </div>

            <div v-if="resolved">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" class="text-gray-500 inline" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>
                <span class="text-gray-600 text-sm ml-2">Duration: {{ interruption.readable_interription_duration }}</span>
            </div>
        </div>
    </base-list-with-heading-entry>
</template>

<script>
    export default {
        props: {
            interruption: {
                required: true,
                type: Object,
            },
        },
        computed: {
            ongoing() {
                return this.interruption.resolved_at === null;
            },
            resolved() {
                return this.interruption.resolved_at !== null;
            }
        },
        methods: {
            detailRoute() {
                return route('service.interruption', {
                    interruption: this.interruption.id
                });
            },
        }
    }
</script>
